import { ERegionCode } from '../../interfaces';

export default [
  'AZ',
  'CA',
  'IL',
  'IN',
  'MO',
  'OH',
  'SC',
  'TN',
  'TX',
] as ERegionCode[];
